module.exports = __webpack_public_path__ + "img/win_item4.bc2c78c1.png";